// Estado de un desvío calculado: texto corto, texto de impreso y color de la etiqueta
export const ESTADOS = {
  ok: { label: "Desvío libre", short: "Libre", cls: "border-emerald-500/40 text-emerald-700" },
  parcial: { label: "Cruza recorrido", short: "Cruza recorrido", cls: "border-lime-500/40 text-lime-700" },
  sin_servicio: { label: "Servicio de rutas no disponible", short: "Servicio de rutas no disponible", cls: "border-amber-500/40 text-amber-700" },
  en_recorrido: { label: "Sobre el recorrido", short: "Sobre el recorrido (sin desvío propio)", cls: "border-sky-500/40 text-sky-700" },
  sin_calle: { label: "Fuera de calle", short: "Fuera de calle: mover encima de la calle", cls: "border-orange-500/40 text-orange-700" },
};
export const estado = (s) => ESTADOS[s] || { label: "Sin alternativa", short: "Sin alternativa", cls: "border-red-500/40 text-red-700" };
